export const enum Language {
    en = "en-US",
    th = "th-TH"
}

export const enum I18NextNs {
    translation = "translation",
    validation = "validation",
    example = "example",
    caption = "caption",
    labelComponent = "labelComponent"
}

export const enum TypeComponent {
    input = "input",
    select = "select",
    switch = "switch",
    datePicker = "datePicker",
    dateRangePicker = "dateRangePicker",
    quaterPicker = "quaterPicker",
    quaterRangePicker = "quaterRangePicker",
    startQuaterPicker = "startQuaterPicker",
    endQuaterPicker = "endQuaterPicker",
    timePicker = "timePicker",
    checkBox = "checkBox",
    radio = "radio",
    textArea = "textArea",
    inputNumber = "inputNumber",
    autoComplete = "autoComplete",
    Upload = "Upload"
}

export const enum TypeFileBlob {
    sharepath = "octet/stream",
    excel = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    word = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    zip = "application/zip",
    pdf = "application/pdf"
}

export const APIStatusCode = {
    /**
     * เป็นการตอบสนองแบบมาตรฐานเมื่อคำขอ HTTP ประสบความสำเร็จ โดยการตอบสนองจะขึ้นอยู่กับวิธีที่ใช้ในการส่งคำขอด้วย
     */
    OK: 200,
    /**
     * คำขอได้รับการตอบสนองแล้ว เริ่มสร้างทรัพยากรใหม่ขึ้นมา
     */
    Created: 201,
    /**
     * คำขอได้รับและกำลังประมวลผลอยู่ แต่ยังดำเนินการไม่เสร็จ ท้ายที่สุดแล้วคำขออาจจะดำเนินการต่อจนเสร็จ หรือไม่สำเร็จก็ได้
     */
    Accepted: 202,
    /**
     * Server เป็น Transforming proxy (เช่น มีการใช้ Web accelerator) ที่ได้รับ 200 OK จากต้นฉบับ แต่มีการส่งคืนค่าการตอบสนองแบบที่ได้รับการแก้ไขกลับม
     */
    NonAuthoritativeInformation: 203,
    /**
     * Server ไม่สามารถ หรือไม่ดำเนินการตามคำขอเนื่องจากมีข้อผิดพลาดจากทาง Client (เช่น คำขอผิดรูปแบบ, ขนาดใหญ่เกินไป ฯลฯ)
     */
    BadRequest: 400,
    /**
     * มีความเหมือนกับ 403 Forbidden (หวงห้าม) แต่ 401 Unauthorized จะใช้เฉพาะเมื่อจำเป็นต้องมีการตรวจสอบสิทธิ์ (Authentication) แต่ว่าล้มเหลว หรือยังไม่ได้รับการยืนยัน
     */
    Unauthorized: 401,
    /**
     * นี่เป็นโค้ดยอดฮิตที่แวะเวียนมาให้เห็นหน้าค่าตากันอยู่บ่อย ๆ เวลาที่เรากรอกที่อยู่ URL ผิด หรือที่อยู่เว็บไซต์นั้นไม่มีอยู่จริง รหัสนี้เป็นการบ่งบอกว่าทรัพยากรที่ถูกส่งคำขอไม่มีอยู่บน Server
     */
    NotFound: 404,
    /**
     * หมายความว่าทรัพยากรที่มีอยู่ไม่รองรับกับวิธีการที่คำขอใช้ เช่น ใช้คำขอแบบ PUT กับทรัพยากรที่อ่านได้อย่างเดียว (Read-Only Resource)
     */
    MethodNotAllowed: 405,
    /**
     * ในคำขอมีไฟล์มัลติมีเดียที่ทาง Server ไม่สนับสนุนอยู่ ตัวอย่างเช่น ทาง Client อัปโหลดไฟล์ภาพ svg+xml ขึ้นไป แต่ Server ไม่รองรับไฟล์นามสกุลดังกล่าว
     */
    UnsupportedMediaType: 415,
    /**
     * ข้อความแจ้งเตือนที่มักถูกใช้อยู่เป็นประจำ เมื่ออยู่ในสถานการณ์ที่ไม่คาดคิด และไม่มีข้อความใดที่เหมาะสม
     */
    InternalServerError: 500,
    /**
     * Server ไม่เข้าใจวิธีการที่คำขอส่งเข้ามา หรือขาดความสามารถที่จะทำตามคำขอนั้นได้ มักใช้กับคุณสมบัติที่กำลังจะเพิ่มเข้ามาในอนาคต
     */
    NotImplemented: 501,
    /**
     * Server ที่ทำตัวเป็น Gateway หรือ Proxy ได้รับการตอบสนองที่ไม่ถูกต้องจาก Server ต้นทาง
     */
    BadGateway: 502,
    /**
     * Server ไม่สามารถดำเนินการตามคำขอได้ สาเหตุอาจจะมาจากมีภาระการทำงานหนักเกินกว่าจะรับไหว หรืออยู่ในช่วงบำรุงรักษา ส่วนใหญ่แล้วจะเป็นแค่เพียงชั่วคราว
     */
    ServiceUnavailable: 503,
    /**
     * Server ที่ทำตัวเป็น Gateway หรือ Proxy ไม่ได้รับการตอบสนองภายในเวลาที่กำหนดจาก Server ต้นทาง 
     */
    GatewayTimeout: 504,
    /**
     * Warning Data
     */
    Warning: 203,
    /**
     * Success
     */
    Success: 200,
    /**
     * Failed
     */
    Failed: 404,
    /**
     * Confirm data
     */
    Confirm: 202,
    /**
     * Error
     */
    Error: 500,
    /**
    * status Duplication use this status code 
    */
    Duplication: 409,
}

export const RegularExpression = {
    // Number: /^\d+$/,
    Number: /^\d+((.)|(.\d{0,2})?)$/, //number and decimal 2 digits
    NumberScientific: /^-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/,
    Th: /^[\u0E00-\u0E7F\s]+$/,
    ThAndNumber: /^[\u0E00-\u0E7F0-9\s]+$/,
    En: /^[A-Za-z\s]+$/g,
    EnAndNumber: /^[A-Za-z0-9\s]+$/g,
    // Email: /^[A-Za-z0-9]+@([\w-]+\.)+[\w-]{2,4}$/g, //เดิมมี . ก่อน @ ไม่ได้
    Email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
    Password: /((?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*-_])(?=.{8,}))/g,
    TelNo: /^[0-9]+$/g,
}

export const enum enumTask {
    NotStart = 97,
    Inprogress = 98,
    Delay = 99,
    Completed = 100,
    CompletedDelay = 101,
    HoldPending = 142
}

export const enum EnumHistory {
    view = 16,
    edit = 17,
    delete = 18,
}

export const enum EnumStatus {
    isActive = 0,
    Active = 1,
}

export const enum EnumSize {
    small = 4,
    mid = 5,
    large = 6,
}

export const enum EnumLogHistoryMode {
    Leave = 1,
    Time = 2,
    Project = 3,
}

export const enum EnumLeaveTypeID {
    SickLeave = 1, //ลาป่วย
    VacationLeave = 2, //ลาพักผ่อน
}

export const enum EnumSaveModeLeave {
    Submit = 1, //ส่งคำขอ SendRequest
    Recall = 2, //ส่งกลับแก้ไข SendEdit
    Approve = 3, //อนุมัติ
    Reject = 4, //ไม่อนุมัติ
    Cancel = 5, //ยกเลิกคำขอ
}

export const enum EnumLeaveStatus {
    Submit_D1 = 1, //รอ ผอ.ส่วน อนุมัติ SendRequest
    Submit_D2 = 2, //รอ ผอ.กอง อนุมัติ
    Approve = 3, //อนุมัติคำขอ
    Recall_D1 = 4, //ผอ.ส่วน ส่งกลับแก้ไข SendEdit
    Recall_D2 = 5, //ผอ.กอง ส่งกลับแก้ไข
    Reject_D1 = 6, //รอ ผอ.ส่วน ไม่อนุมัติ
    Reject_D2 = 7, //รอ ผอ.กอง ไม่อนุมัติ
    Canceled = 8, //ยกเลิกคำขอ
}

export const enum EnumLeavePosition {
    ApproverDD = 1, // ผอ.กองคุ้มครองซากดึกดำบรรพ์    
    // ApproverVP = 2, // ผอ.ฝ่าย 
    // ApproverDV = 3, // ผอ.ส่วน
    ApproverVPDV = 2, // ผอ.ส่วน/ผอ.ฝ่าย
    ApproverDA = 3, // แผนก
}

export const enum EnumModeProfiles {
    Leave = 1,
    Time = 2,
}

export const enum EnumColorStatusHistory {
    SendRequest = "#AEE2FF", //ฟ้า
    SendEdit = "#FFDCA9", //เหลือง
    Approve = "#BCE29E", //เขียว
    Reject = "#D0BFFF", //ม่วง  
    Cancel = "#FF9F9F", //แดง
}

export const enum EnumProjectColorStatusHistory
{
    Green = "#BCE29E", //เขียว
    Orange = "#FFC38B", //ส้ม
    Blue = "#AEE2FF", //ฟ้า
    Yellow = "#FFDCA9", //เหลือง
    Purple = "#D0BFFF", //ม่วง  
    Red = "#FF9F9F", //แดง
}

export const enum EnumMasterData {
    NormalWork = 19,
    Late = 20,
    OnDuty = 21,
    Absent = 22,
    HalfAbsent = 23,
    Sick = 24,
    HalfSick = 25,
    Business = 26,
    HalfBusiness = 27,
    OnVacation = 28,
    HalfOnVacation = 29,
    OtherLeave = 30,
    LeaveAffectSalary = 31
}

export const enum EnumRegisterTimelineType {
    Normal = 1, //ปกติ
    FastTrack = 2, //เร่งด่วน
}

export const enum EnumSaveModeProject {
    Draft = 1, //บันทึกร่าง
    Submit = 2, //ส่งคำขอ SendRequest
    Recall = 3, //ส่งกลับแก้ไข
    Approve = 4, //อนุมัติ
    Reject = 5, //ไม่อนุมัติ
    Cancel = 6, //ยกเลิกคำขอ
    UpdateFile = 7, //บันทึกไฟล์
    Save = 8, //บันทึก
}

/**
* @enum 0 = ร่างข้อเสนอโครงการ
* @enum 1 = รอการตรวจสอบ
* @enum 2 = พร้อมนำเสนอ
* @enum 3 = รอดำเนินการแก้ไข
* @enum 4 = รอตรวจสอบการแก้ไข
* @enum 5 = รอส่งบันทึกผลคะแนน
* @enum 6 = รอบันทึกผลการให้คะแนน
* @enum 7 = รอพิจารณาสรุปคะแนน
* @enum 8 = รอพิจารณาจัดลำดับโครงการ
* @enum 9 = รอบันทึกมติการจัดลำดับ
* @enum 10 = รอพิจารณาข้อเสนอโครงการ
* @enum 11 = อนุมัติโครงการ
* @enum 12 = ไม่อนุมัติโครงการ
* @enum 13 = รอการรายงานผล ไตรมาส 1
* @enum 14 = รอการรายงานผล ไตรมาส 2
* @enum 15 = รอการรายงานผล ไตรมาส 3
* @enum 16 = รอการรายงานผล ไตรมาส 4
* @enum 17 = รอตรวจสอบผลการรายงาน ไตรมาส 1
* @enum 18 = รอตรวจสอบผลการรายงาน ไตรมาส 2
* @enum 19 = รอตรวจสอบผลการรายงาน ไตรมาส 3
* @enum 20 = รอตรวจสอบผลการรายงาน ไตรมาส 4
* @enum 21 = รอแก้ไขการรายงานผล ไตรมาส 1
* @enum 22 = รอแก้ไขการรายงานผล ไตรมาส 2
* @enum 23 = รอแก้ไขการรายงานผล ไตรมาส 3
* @enum 24 = รอแก้ไขการรายงานผล ไตรมาส 4
* @enum 25 = รอรับรองผลปิดโครงการ
* @enum 26 = รอตรวจสอบผลการรายงานไตรมาสสุดท้าย พร้อมปิดโครงการ
* @enum 27 = รอแก้ไขการรายงานผลไตรมาสสุดท้าย พร้อมรายงานปิดโครงการ
* @enum 28 = ตรวจสอบผลเสร็จสิ้นของไตรมาส และปิดโครงการ
* @enum 29 = ขยายระยะเวลา
* @enum 30 = ยกเลิกโครงการ
* @enum 31 = ยกเลิกคำขอ  
* @enum 32 = อนุมัติการรายงานผล  
* @enum 33 = บันทึกร่าง  
* @enum 34 =  รอรายงานผลไตรมาสสุดท้าย พร้อมรายงานปิดโครงการ  
* @enum 35 = รอรายงานผลปิดโครงการ  
* @enum 36 = ปรับแผนโครงการ
*/
export const enum EnumProjectStatusID {
    /**
	* ร่างข้อเสนอโครงการ
	*/
    nStatusID_0 = 0,
    /**
    * รอการตรวจสอบ
    */
    nStatusID_1 = 1,
    /**
    * พร้อมนำเสนอ
    */
    nStatusID_2 = 2,
    /**
    * รอดำเนินการแก้ไข
    */
    nStatusID_3 = 3,
    /**
    * รอตรวจสอบการแก้ไข
    */
    nStatusID_4 = 4,
    /**
    * รอส่งบันทึกผลคะแนน
    */
    nStatusID_5 = 5,
    /**
    * รอบันทึกผลการให้คะแนน
    */
    nStatusID_6 = 6,
    /**
    * รอพิจารณาสรุปคะแนน
    */
    nStatusID_7 = 7,
    /**
    * รอพิจารณาจัดลำดับโครงการ
    */
    nStatusID_8 = 8,
    /**
    * รอบันทึกมติการจัดลำดับ
    */
    nStatusID_9 = 9,
    /**
    * รอพิจารณาข้อเสนอโครงการ
    */
    nStatusID_10 = 10,
    /**
    * อนุมัติโครงการ
    */
    nStatusID_11 = 11,
    /**
    * ไม่อนุมัติโครงการ
    */
    nStatusID_12 = 12,
    /**
    * รอการรายงานผล ไตรมาส 1
    */
    nStatusID_13 = 13,
    /**
    * รอการรายงานผล ไตรมาส 2
    */
    nStatusID_14 = 14,
    /**
    * รอการรายงานผล ไตรมาส 3
    */
    nStatusID_15 = 15,
    /**
    * รอการรายงานผล ไตรมาส 4
    */
    nStatusID_16 = 16,
    /**
    * รอตรวจสอบผลการรายงาน ไตรมาส 1
    */
    nStatusID_17 = 17,
    /**
    * รอตรวจสอบผลการรายงาน ไตรมาส 2
    */
    nStatusID_18 = 18,
    /**
    * รอตรวจสอบผลการรายงาน ไตรมาส 3
    */
    nStatusID_19 = 19,
    /**
    * รอตรวจสอบผลการรายงาน ไตรมาส 4
    */
    nStatusID_20 = 20,
    /**
    * รอแก้ไขการรายงานผล ไตรมาส 1
    */
    nStatusID_21 = 21,
    /**
    * รอแก้ไขการรายงานผล ไตรมาส 2
    */
    nStatusID_22 = 22,
    /**
    * รอแก้ไขการรายงานผล ไตรมาส 3
    */
    nStatusID_23 = 23,
    /**
    * รอแก้ไขการรายงานผล ไตรมาส 4
    */
    nStatusID_24 = 24,
    /**
    * รอรับรองผลปิดโครงการ
    */
    nStatusID_25 = 25,
    /**
    * รอตรวจสอบผลการรายงานไตรมาสสุดท้าย พร้อมปิดโครงการ
    */
    nStatusID_26 = 26,
    /**
    * รอแก้ไขการรายงานผลไตรมาสสุดท้าย พร้อมรายงานปิดโครงการ
    */
    nStatusID_27 = 27,
    /**
    * ตรวจสอบผลเสร็จสิ้นของไตรมาส และปิดโครงการ
    */
    nStatusID_28 = 28,
    /**
    * ขยายระยะเวลา
    */
    nStatusID_29 = 29,
    /**
    * ยกเลิกโครงการ
    */
    nStatusID_30 = 30,   
    /**
    * ยกเลิกคำขอ
    */
    nStatusID_31 = 31,
    /**
    * อนุมัติการรายงานผล
    */
    nStatusID_32 = 32,
    /**
    * บันทึกร่าง
    */
    nStatusID_33 = 33,
    /**
    * รอรายงานผลไตรมาสสุดท้าย พร้อมรายงานปิดโครงการ
    */
    nStatusID_34 = 34,         
    /**
    * รอรายงานผลปิดโครงการ
    */
    nStatusID_35 = 35,   
    /**
    * ปรับแผนโครงการ
    */
    nStatusID_36 = 36,  
    /**
    * บันทึก รายงานผลไตรมาส เลขา
    */
    nStatusID_99 = 99,  
}

/**
* @enum 0 = บันทึกร่าง
* @enum 1 = รอเลขาตรวจสอบ
* @enum 2 = เลขาตรวจสอบแล้ว
*/
export const enum EnumProjectPresentStatusID {
    /**
	* บันทึกร่าง
	*/
    nPresentStatusID_0 = 0,
    /**
    * รอเลขาตรวจสอบ
    */
    nPresentStatusID_1 = 1,
    /**
    * เลขาตรวจสอบแล้ว
    */
    nPresentStatusID_2 = 2,
}

export const enum EnumProjectPanel {
    Panel0 = 1, // ข้อมูลผู้ขอรับทุน
    Panel1 = 2, // 1. หลักการและเหตุผล
    Panel2 = 3, // 2. วัตถุประสงค์และเป้าหมาย
    Panel3 = 4, // 3. ความสอดคล้องและความสัมพันธ์กับยุุทธศาสตร์/นโยบาย/แผนที่เกี่ยวข้อง
    Panel4 = 5, // 4. พื้นที่ดำเนินการ
    Panel5 = 6, // 5. กลุ่มเป้าหมาย
    Panel6 = 7, // 6. ระยะเวลาดำเนินการ
    Panel7 = 8, // 7. แผนการดำเนินงาน
    Panel8 = 9, // 8. ตัวชี้วัดความสำเร็จและผลการดำเนินงานโครงการ
    Panel9 = 10, // 9. วงเงินงบประมาณ
    Panel10 = 11, // 10. การบริหารโครงการ
    Panel11 = 12, // 11. ปัญหา/อุปสรรคที่คาดว่าจะเกิดขึ้นระหว่างดำเนินการและแนวทางการแก้ไข
    Panel12 = 13, // 12. การติดตามนิเทศโครงการ
}

export const enum EnumProjectPlan {
    WorkPlan = 14, // Plan 2/1 WorkPlan แผนการปฎิบัติงาน
    SpendingPlan = 15, // Plan 2/2 SpendingPlan แผนการใช้จ่ายเงิน
}

export const enum EnumStatusMode {
    Delete = 0,
    View = 1,
    Edit = 2,
    Clear = 3,
}

export const OptionsProjectStatus_1 = [
    { value: "Y", label: "ใช่" },
    { value: "N", label: "ไม่ใช่" },
];

export const OptionsProjectStatus_2 = [
    { value: "Y", label: "มี" },
    { value: "N", label: "ไม่มี" },
];

export const OptionsProjectStatus_3 = [
    { value: "Y", label: "เฉพาะเจาะจง" },
    { value: "N", label: "ไม่เฉพาะเจาะจง" },
];


export const enum EnumProjectActivityType {
    Manage = 94, //94 บริหารโครงการ
    Operate = 95, //95 ดำเนินงานโครงการ >> (1 = แผน Plan, 2 = กิจกรรม Activity) 
}

export const enum EnumProjectMonitorType {
    Start = 105, //105 ระยะเริ่มต้นโครงการ
    Proceed = 106, //106 ระหว่างดําเนินการ
    End = 107, //107 สิ้นสุดโครงการ
}

export const enum EnumStatusActivity {
    isWaiting = 0,
    isReported = 1,
    isApproved = 2
}

export const enum EnumProjectStatusFinalScore
{
    PassFinalScore = "ผ่านเกณฑ์การประเมินฯ", //เขียว
    NotPassFinalScore = "ไม่ผ่านเกณฑ์การประเมินฯ", //แดง
    WaitFinalScore = "รอสรุปผลคะแนน", //เทา
}